'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _BellOutlined = _interopRequireDefault(require('./lib/icons/BellOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _BellOutlined;
exports.default = _default;
module.exports = _default;